import { create } from 'zustand'

interface CacheEntry<T = unknown> {
  data: T
  generatedAt: string
}

interface ReportCacheState {
  entries: Record<string, CacheEntry>
  getEntry: <T>(key: string) => CacheEntry<T> | undefined
  setEntry: <T>(key: string, data: T, generatedAt: string) => void
}

/** In-memory cache of fetched report data, keyed by service:address:period. */
export const useReportCache = create<ReportCacheState>((set, get) => ({
  entries: {},
  getEntry: <T>(key: string) => get().entries[key] as CacheEntry<T> | undefined,
  setEntry: (key, data, generatedAt) =>
    set((s) => ({ entries: { ...s.entries, [key]: { data, generatedAt } } })),
}))
